var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1022_23892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.54561 14.7963C8.95271 14.5388 8.56958 13.9549 8.56958 13.3085V12.6693C8.56958 12.332 8.29614 12.0586 7.95886 12.0586C7.62158 12.0586 7.34814 12.332 7.34814 12.6693V13.3085C7.34814 14.4417 8.01977 15.4654 9.05924 15.9167C9.13843 15.9511 9.22093 15.9673 9.30208 15.9673C9.53799 15.9673 9.76268 15.8298 9.86264 15.5997C9.99693 15.2903 9.85502 14.9306 9.54561 14.7963Z",
    fill: "#2A5637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4855 1.30307C15.3896 1.05907 15.2491 0.84051 15.068 0.653447C14.7467 0.32151 14.3212 0.113541 13.8698 0.0679472C11.866 -0.134678 9.70112 0.610104 7.99996 2.0707C6.29878 0.610041 4.13403 -0.134615 2.13018 0.0679472C1.67878 0.113541 1.25325 0.32151 0.931933 0.653447C0.750871 0.840541 0.610402 1.05907 0.514465 1.30317C-0.396348 3.62035 -0.0850353 6.45035 1.34715 8.87335C2.08965 10.1295 3.09471 11.2014 4.25365 11.9731C5.39046 12.7301 6.64918 13.1797 7.89371 13.282C7.91034 13.2834 7.92696 13.2795 7.94371 13.2795H8.0564C8.07309 13.2795 8.08975 13.2834 8.1064 13.282C9.35093 13.1798 10.6097 12.7279 11.7465 11.9709C12.9054 11.1992 13.9104 10.1284 14.653 8.87223C16.0851 6.4492 16.3963 3.62035 15.4855 1.30307Z",
    fill: "#489B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2.07068C6.29878 0.610027 4.13403 -0.134629 2.13018 0.067933C1.67878 0.113527 1.25325 0.321496 0.931934 0.653433C0.750871 0.840527 0.610402 1.05906 0.514465 1.30315C-0.396348 3.62034 -0.0850353 6.45034 1.34715 8.87334C2.08965 10.1295 3.09472 11.2014 4.25365 11.9731C5.39046 12.7301 6.64918 13.1797 7.89371 13.282C7.91034 13.2833 7.92697 13.2795 7.94372 13.2795H8.00006V2.07068H8Z",
    fill: "#A2CE86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1022_23892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/Leaf.807ec9d85ebfedc0c36f8d391169afb6.svg";
export { ForwardRef as ReactComponent };